import firebase from 'firebase/app';
import isNil from 'lodash/isNil';

let asyncFirestore = null;

// Lazy load firestore with async import is important for performance

export default () => {
    if (isNil(asyncFirestore)) {
        asyncFirestore =
            import (
                /* webpackChunkName: "chunk-firestore" */
                'firebase/firestore'
            ).then(() => {
                firebase.firestore().settings({});
                //firebase.firestore().enablePersistence({ synchronizeTabs: true });
                return firebase.firestore();
            });
    }
    return asyncFirestore;
};

// Lazy load auth with async import is important for performance

let asyncAuth = null;

export const auth = () => {
    if (isNil(asyncAuth)) {
        asyncAuth =
            import (
                /* webpackChunkName: "chunk-auth" */
                'firebase/auth'
            ).then(() => {
                return firebase.auth();
            });
    }
    return asyncAuth;
};

// Lazy load auth with async import is important for performance

let asyncDatabase = null;

export const database = () => {
    if (isNil(asyncDatabase)) {
        asyncDatabase =
            import (
                /* webpackChunkName: "chunk-database" */
                'firebase/database'
            ).then(() => {
                return firebase.database();
            });
    }
    return asyncDatabase;
};

// Lazy load storage with async import is important for performance

let asyncStorage = null;

export const storage = () => {
    if (isNil(asyncStorage)) {
        asyncStorage =
            import (
                /* webpackChunkName: "chunk-storage" */
                'firebase/storage'
            ).then(() => {
                return firebase.storage();
            });
    }
    return asyncStorage;
};